<script lang="ts" setup>
import type { License } from "~/modules/license/models/License.interface";

defineProps<{
  organizationCode?: number;
  license?: License;
}>();

defineEmits(["uploadSuccess", "uploadError"]);
</script>

<template>
  <license-content-properties
    v-if="license"
    :organization-code="organizationCode"
    :license="license"
    @upload-success="$emit('uploadSuccess')"
    @upload-error="$emit('uploadError', $event)"
  />
  <license-content-export-id-card :organization-code="organizationCode" />
</template>
